import { DATETIME_FORMAT } from '../constants/date';
import { CustomDatePipe } from '../pipes/custom-date.pipe';
import { RowMapper } from '../utils/row-mapper';
import { Role } from './entitlements/role';
import { NewLinkedUser } from './new-linked-user';
import { Organization } from './organization';
import { UserAffiliation } from './user-affiliation';

export enum NewUserRequestStatus {
  ALL = 'All',
  PENDING = 'Pending',
  APPROVED = 'Approved',
  DENIED = 'Denied'
}

export class NewUserRequestForm {
  id: string;
  submitterName: string;
  submitterEmail: string;
  submitterOrganization: string;

  userId: number;
  userName: string;
  firstName: string;
  lastName: string;
  emailId: string;
  mobileNo: string;
  employerId: number;
  employer: string;
  jobTitle: string;
  otherJobTitle: string;
  employerIdReachIL: number = null;
  employerReachIL: string;
  jobTitleReachIL: string = null;
  otherJobTitleReachIL: string;
  employerIdAcoAetna: number = null;
  employerAcoAetna: string;
  jobTitleAcoAetna: string = null;
  otherJobTitleAcoAetna: string;
  status: string;

  role: Role = null;
  roleReachIL: Role = null;
  roleAcoAetna: Role = null;

  organization: Organization;
  affiliation: UserAffiliation;
  affiliationReachIL: UserAffiliation;
  affiliationAcoAetna: UserAffiliation;

  linkedReachILUserId: number;
  linkedReachILUser: NewLinkedUser;
  linkedAcoAetnaUserId: number;
  linkedAcoAetnaUser: NewLinkedUser;

  uniteUsAccess: boolean;
  sudSmiProgramDashboard: boolean;
  learningManagementSystem: boolean;
  notes: string;
  acoReachILSelected: boolean;
  acoAetnaSelected: boolean;

  addedBy: string;
  addedDateTime: Date;
  modifiedBy: string;
  modifiedDateTime: Date;
  orgId: number;
  orgLevel: number;
}

export class NewUserRequestFormRow {
  id: string;
  name: string;
  email: string;
  organization: string;
  status: string;
  asmName: string;
  addedDateTime: Date;
  modifiedDateTime: Date;
  requestedDateFormatted: string;
  updatedDateFormatted: string;
}

export class NewUserRequestFormRowMapper implements RowMapper<NewUserRequestForm, NewUserRequestFormRow> {
  constructor(private datePipe: CustomDatePipe) {}

  mapRows(values: NewUserRequestForm[]): NewUserRequestFormRow[] {
    if (values && values.length) {
      return values.map((value) => {
        return this.mapRow(value);
      });
    }

    return [];
  }

  mapRow(value: NewUserRequestForm) {
    const row = new NewUserRequestFormRow();
    row.id = value.id;
    row.name = `${value.firstName} ${value.lastName}`;
    row.email = value.emailId;
    row.organization = value.organization?.orgDescription;
    row.status = value.status;
    row.asmName = value.submitterName;
    row.addedDateTime = value.addedDateTime;
    row.modifiedDateTime = value.modifiedDateTime;
    row.requestedDateFormatted = this.datePipe.transform(value.addedDateTime, DATETIME_FORMAT);
    row.updatedDateFormatted = this.datePipe.transform(value.modifiedDateTime, DATETIME_FORMAT);

    return row;
  }
}
